module.exports = __webpack_public_path__ + "static/media/switch_on.57c61e16.png";